let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// console.log(items)
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});
});

function auto_grow(element) {
  element.style.height = "5px";
  element.style.height = (element.scrollHeight) + "px";
}

// If transperent
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
var topbar = document.querySelector(".utility-bar");
if (transperentElment) {
  header.classList.add("allow-transparent-header");
  topbar.classList.add("allow-transparent-header");
}

const topbar_swiper = new Swiper(".announce_cover", {
  loop: true,
  speed: 1000,
  scrollbar: {
    el: ".announce_cover .swiper-pagination",
    hide: false,
    draggable: true
  },
  pagination: {
    el: ".announce_cover .swiper-pagination",
    type: "progressbar",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 0 },
    768: { slidesPerView: 1, spaceBetween: 0 },
    990: { slidesPerView: 1, spaceBetween: 0 },
  },
});

const testimonial_swiper = new Swiper(".testimonial-box-wrapper", {
  loop: true,
  centeredSlides: true,
  speed: 1000,
  autoplay: 
  {
    delay: 2000,
  },
  scrollbar: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    hide: false,
    draggable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 20, centeredSlides: true },
    390: { slidesPerView: 1.3, spaceBetween: 20, centeredSlides: true },
    768: { slidesPerView: 2, spaceBetween: 30, centeredSlides: true },
    992: { slidesPerView: 3.5, spaceBetween: 30 },
    1200: { slidesPerView: 3.8, spaceBetween: 30 },
  },
});

const swiper_slider = new Swiper(".logo-list-wrapper", {
  slidesPerView: 3,
  grabCursor: true,
  loop: false,
  spaceBetween: 0,
  effect: "slide",
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  navigation: {
    nextEl: ".logo-list_arrow_next",
    prevEl: ".logo-list_arrow_prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    375: {
      slidesPerView: 2.3,
      spaceBetween: 0,
      loop: false,
      centeredSlides: true,
    },
    750: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
});

if (document.body.clientWidth < 991) {
  const icon_swiper = new Swiper(".text-with-icon-blocks", {
    loop: true,
    speed: 1000,
    scrollbar: {
      el: ".text-with-icon-blocks .swiper-pagination",
      hide: false,
      draggable: true
    },
    pagination: {
      el: ".text-with-icon-blocks .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 0 },
      400: { slidesPerView: 1, spaceBetween: 0 },
      575: { slidesPerView: 2, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 10 },
      990: { slidesPerView: 2, spaceBetween: 10 },
    },
  });
}

// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        if (!localStorage.getItem("firstLoad")) {
            document.querySelector(".custom-model-main").classList.add("model-open");
            localStorage.setItem("firstLoad", "true");
        }
    }, 3000);

    document.querySelectorAll(".close-btn, .bg-overlay").forEach(function (element) {
        element.addEventListener("click", function () {
            document.querySelector(".custom-model-main").classList.remove("model-open");
        });
    });

    if (document.body.clientWidth < 991) {
        const lastCollage = document.querySelector(".last_collage.image_banner_collage_item");
        const collageSecond = document.querySelector(".collage_second.image_banner_collage_item");
        if (lastCollage && collageSecond) {
            collageSecond.after(lastCollage);
        }
    }
    if (document.body.clientWidth < 750) {
        const imageMedia = document.querySelector(".about-image-text-bg.image-with-text__media-item");
        const imageText = document.querySelector(".about-image-text-bg.image-with-text__text-item");
        if (imageMedia && imageText) {
            imageText.after(imageMedia);
        }
    }

    document.querySelectorAll(".faq_accordion .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq_accordion .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});


// ====== presse page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".presse_accordion .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            
            document.querySelectorAll(".presse_accordion .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    document.querySelectorAll(".presse-page_main_wrapper .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            
            document.querySelectorAll(".presse-page_main_wrapper .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });

            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});



// faq tabs toggal start
// const faqTitles = document.querySelectorAll('[data-faq_content]');

// faqTitles.forEach(faq => {
//   faq.addEventListener('click', function() {
//     const faqItem = faq.parentNode; 
//     const faqContentt = faqItem; 
//     document.querySelectorAll('[data-faq_content].active').forEach(item => {
//       if (item !== faqContentt) {
//         item.classList.remove('active');
//       }
//     });

//     faqContentt.classList.toggle('active');
//   });
// });
  
// });
const Ffaqopen = document.querySelectorAll("variant-selects [data-faq_content]");
// Ffaqopen[0].classList.add('is_open');

function togal_tabs (item) {
  if(item.classList.contains('is_select')) return;
  item.classList.add('is_select');
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();

// faq tabs toggal end

//PDP Review Scroll
window.addEventListener('DOMContentLoaded', (event) => {
  const reviewBtn = document.querySelector('.review_btn');
  const closeBtn = document.querySelector('.close_btn');
  const popupContainer = document.querySelector('.popup_container');

  if (reviewBtn) {
    reviewBtn.addEventListener('click', function() {
      if (popupContainer) {
        popupContainer.classList.toggle('hidden');
      } 
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (popupContainer) {
        popupContainer.classList.add('hidden');
      } 
    });
  } 
});


//footer accordian
// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();

// slider_pdp

  function slider_pdp() {
      const product_material = new Swiper(".product_material", {
    loop: false,
    slidesPerView: 5,
    centeredSlides: false,
    speed: 1000, 
    navigation: {
      nextEl: ".product_material .swiper-button-next",
      prevEl: ".product_material .swiper-button-prev",
    },
    pagination: {
      el: ".product_material .swiper-pagination",
      clickable: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 3, spaceBetween: 0 },
      390: { slidesPerView: 3, spaceBetween: 0 },
      768: { slidesPerView: 3, spaceBetween: 0 },
      992: { slidesPerView: 4, spaceBetween: 0 },
      1200: { slidesPerView: 5, spaceBetween: 0 },
    },
  });
  }




// function truncateText (element, wordLimit){
//   let text = element.innerHTML.trim();
//   let words = text.split(" ");

//   if (words.length > wordLimit) {
//     let truncatedText = words.slice(0, wordLimit - 1).join(" ");
//     let lastWord = words[wordLimit - 1];
//     element.innerHTML = `${truncatedText} <a href="#section1" data-target="section1" class="read-more">${lastWord}...</a>`;

//     // Expand on click
//     element.querySelector(".read-more").addEventListener("click", function (e) {
//       let targetId = this.getAttribute("data-target");
//       let targetElement = document.getElementById(targetId);
//       // setTimeout(() => {
//         // console.log("targetElement",targetElement)
//         targetElement.querySelector('[data-faq_content]').classList.add("is_open");
//       // }, 2000);
//     });
//   }
// };

// if(document.querySelectorAll("[data-read-more]")){
//   document.querySelectorAll("[data-read-more]").forEach((element) => {
//     truncateText(element, 30); // Change 20 to the desired word limit
//   });
// }


// --------------readmorebtn for PDP-------- 
const readmorebtn = document.querySelector(".read-more-section");
if (readmorebtn) {
  
readmorebtn.addEventListener("click", function(event) {
        event.preventDefault(); 
        document.getElementById("product-description").scrollIntoView({ behavior: 'smooth' });
    });
}

// ------------- Material close body click
// const faqClose = document.querySelector('variant-selects-custdev .swatch-head');
// if (faqClose) {
  
// document.body.addEventListener('click', function (e) {
//   if (faqClose && faqClose.classList.contains('is_open')) {
//     if (!faqClose.contains(e.target)) {
//       faqClose.classList.remove('is_open');
//     }
//   }
// });
// }

// ====================== prees page open accordion
const logoClick = document.querySelectorAll('.logo-list-item-icon');
if (logoClick) {
logoClick.forEach(item => {
  item.addEventListener('click', function () {
    const dataTitle = this.getAttribute('data-title');
    localStorage.setItem('selectedLogoTitle', dataTitle);
  });
});
}

setTimeout(() => {
  const storedTitle = localStorage.getItem('selectedLogoTitle');
  const matchingTrigger = document.querySelector(`.presse-page-content .accordion[data-title-page="${storedTitle}"]`);

    if (matchingTrigger) {
      matchingTrigger.click();
    }
  
}, 500); 

// ====================== contact page submit click 
const submitBtn = document.querySelector('.contact__button button');
const checkbox = document.querySelector('#reqid_checkmark');
const errorSpan = checkbox?.nextElementSibling?.nextElementSibling; // The <span> after label

if (submitBtn && checkbox && errorSpan) {
  submitBtn.addEventListener('click', function (e) {
    if (!checkbox.checked) {
      e.preventDefault(); 
      errorSpan.style.display = 'block';
    } else {
     errorSpan.style.display = 'none';
    }
  });
}


const readmore = document.querySelector("[data-more-discretion]") || null;
const description = document.querySelector("#product-description") || null;

if (readmore && description) {
  readmore.addEventListener("click", (e) => {
    e.preventDefault();

    // Get position of the description element
    const targetPosition = description.getBoundingClientRect().top + window.scrollY - 100;

    // Smooth scroll to that position
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth"
    });
  });
}


document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.var-outer');
  if (!swatch) return;

  const materialTitle = swatch.dataset.materialTitle;
  const input = document.getElementById('selected-material-input');

  if (materialTitle && input) {
    input.value = materialTitle;
  }
});

